import request from './request';

export function redeemCdkey(code) {
  return request.post('/api/cdkey/redeem', { code });
}
export function getCdkeyRecords() {
  return request.get('/api/cdkey/myRecords');
}
